/* eslint-disable prettier/prettier */
import { pipeline } from "./pipeline";

export { pipeline as checkoutAnalysisPipeline } from "./pipeline";

export const trackCheckoutAnalysisEvents = (): void => {
  // TODO: remove 'if' after metrics dark launch strategies would be over
  if (window.location.origin !== 'https://stage.rbo.org.uk') return;

  window.addEventListener("beforeunload", () => pipeline.tracking.markWebsiteAsClosed());
  window.addEventListener("load", () => pipeline.tracking.checkIfSessionIsAbandoned());
  window.addEventListener("load", () => pipeline.tracking.listenForEvents());
};

